import { render, staticRenderFns } from "./AgeingOfReceivables.vue?vue&type=template&id=3e2e8e3f&"
import script from "./AgeingOfReceivables.vue?vue&type=script&lang=js&"
export * from "./AgeingOfReceivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports